import React, { useEffect } from 'react';
import Dashboard from './Dashboard';
import Sidebar from '../Sidebar/Sidebar';
import { Helmet } from 'react-helmet-async';
import chatFavicon from "../assets/favicon/favicon.ico";
import { useAPI } from '../Context/MyContext';
import { useNavigate } from 'react-router-dom';
const DashboardManagement = () => {

  const navigate = useNavigate();
  const { checkAccountStatus, logoutUser } = useAPI();


  // useEffect(() => {
  //   const verifyAccountStatus = async () => {
  //     try {
  //       const status = await checkAccountStatus();

  //       if (status.accountStatus !== "active") {
  //         navigate("/inactive");
  //         logoutUser();

  //       }
  //     } catch (error) {
  //       console.error("Failed to check account status:", error);
  //     }
  //   };

  //   verifyAccountStatus();
  // }, []);


  useEffect(() => {
    const verifyAccountStatus = async () => {
      try {
        const status = await checkAccountStatus();

        if (status.code === "ACCOUNT_INACTIVE") {
          navigate("/inactive");
          logoutUser();
          return;
        }

        if (status.code === "PLAN_EXPIRED") {
          navigate("/subscription-expired");
          logoutUser();
          return;
        }
      } catch (error) {
        console.error("Failed to check account status:", error);
      }
    };

    verifyAccountStatus();
  }, []);

  return (
    <>
      <Helmet>
        <title>Dashboard | WhatGrowPro</title>
        <meta
          name="description"
          content="Manage real-time customer conversations using WhatGrowPro’s Live Chat — connect instantly and improve customer satisfaction."
        />
        <meta name="keywords" content="Live Chat, WhatsApp automation, customer support, WhatGrowPro" />
        <link rel="icon" type="image/png" href={chatFavicon} />
      </Helmet>
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar: fixed height, non-scrollable */}
        <div className="h-screen  bg-gray-100 flex-shrink-0">
          <Sidebar />
        </div>

        {/* Main content: scrollable */}
        <div className="flex-1 overflow-y-auto bg-gray-100">
          <div className="p-">
            <Dashboard />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardManagement;
